<div class="datatable-wrapper" [class.filter-right]="filterConfig()?.position === 'right'">
  @if (filterService.hasFilters() && filterService.doShow() && !mobileService.isOn()) {
    <div class="filter-wrapper" [style.order]="filterConfig()?.position === 'right' ? 2 : 0">
      <table-datatable-filters
        [filters]="filterService.filters()"
        [activeFilters]="filterService.effectiveActiveFilters()"
        [position]="filterConfig()?.position ?? 'left'"
        [hasApplyButton]="filterConfig()?.hasApplyButton ?? false"
        [width]="filterConfig()?.width ?? 240"
        [selectionFilters]="filterConfig()?.selectionFilters ?? []"
        [selectedSelectionFilter]="filterConfig()?.selectedSelectionFilter"
        [showSavedFiltersButton]="!!filterConfig()?.selectionFilters?.length"
        (filterChange)="onFilterChange($event)"
        (saveSelectionFilter)="filterConfig()?.onSaveSelectionFilter?.($event)"
        (editSelectionFilter)="filterConfig()?.onEditSelectionFilter?.($event)"
        (deleteSelectionFilter)="filterConfig()?.onDeleteSelectionFilter?.($event)"
        (selectionFilterChange)="filterConfig()?.onSelectionFilterChange?.($event)"
        (closeEvent)="filterService.onFilterToggle()"
      ></table-datatable-filters>
    </div>
  }
  <vectronic-card class="datatable" [shadowMargin]="true" #datatableCard>
    @if (!datatableConfig()?.hideHeader) {
      <table-datatable-header
        class="datatable__header"
        [datatableConfig]="datatableConfig()"
        [isLoadingCSV]="isLoadingCSV()"
        [titleExtension]="titleExtension()"
        [dynamicTableTitle]="dynamicTableTitle()"
        [hasData]="hasData()"
        (searchFieldEdit)="onSearchFieldChanged($event)"
        (columnSelectionChange)="onColumnSelectionChange($event)"
        (editColumn)="columnService.openEditColumnsModal()"
        (compactToggle)="columnService.toggleCompactMode()"
        [isCompact]="columnService.isCompact()"
        (export)="exportCsv()"
        (exportSelected)="exportCsv(true)"
        (filterToggle)="filterService.onFilterToggle()"
        [filtersState]="filterService.state()"
        header
      >
        <ng-template #buttons>
          <ng-template [ngTemplateOutlet]="headerButtons"></ng-template>
        </ng-template>
      </table-datatable-header>
    }

    <div class="datatable__container" body>
      <table-datatable-body
        class="datatable__body"
        [ngClass]="{ 'has-paginator': !datatableConfig()?.disablePagination }"
        [isLoading]="isLoading() || isInitialLoading() || isLoadingUntilScrollUp()"
        [loadingProgress]="loadingProgress()"
        [data]="isInitialLoading() ? [] : searchedData()"
        [datatableConfig]="datatableConfig()"
        [displayColumns]="columnService.displayColumns()"
        [isCompactModeActivated]="columnService.isCompact()"
        [pageIndex]="pageIndex()"
        [pageSize]="columnService.pageSize()"
        (reorderColumns)="onColumnReorder($event)"
        (sortTable)="tableSort.emit($event)"
        (rowClicked)="rowClicked.emit($event)"
      >
      </table-datatable-body>
    </div>
    @if (!datatableConfig()?.disablePagination) {
      <mat-card-footer>
        <table-datatable-paginator
          class="datatable__paginator"
          [tableWidth]="datatableWidth()"
          [pageIndex]="pageIndex()"
          [pageSize]="columnService.pageSize()"
          [showDataCountAsPageSizeOption]="paginationConfig()?.showDataCount"
          [pageSizeOptions]="paginationConfig()?.options"
          [hidePageSize]="paginationConfig()?.hidePageSize"
          [dataCount]="computedDataCount()"
          [maxPageIndex]="maxPageIndex()"
          (pageChange)="onPageChanged($event)"
          (pageIndexChange)="onPageIndexChanged($event)"
        ></table-datatable-paginator>
      </mat-card-footer>
    }
  </vectronic-card>
</div>
